import { searchBrandMediaTypes } from '@/app/library/constants';
import {
  baseQueryParamMapping,
  defaultReportingPeriod,
} from '@/components/core/analytics/queryParamMapping';
import { getMetrics, METRICS } from '@/models/metrics.enum';
import { PLATFORM_CONNECTION } from '@/models/platform/platform-connection.enum';

export const useYourPosts = () => {
  const metrics = getMetrics('yourPosts');

  return {
    title: 'YouTube Posts',
    channelFilterKey: 'youtube',
    filters: {
      brandMediaTypes: [searchBrandMediaTypes.YOUTUBE_OWNED],
      default: {
        captionContain: [],
        captionNotContain: [],
        contentTags: [],
        contentTagMatchType: 'ANY',
        postType: [],
        privacy: [],
        reportingPeriod: defaultReportingPeriod,
        sort: {
          sortOrder: 'DESC',
          selected: { value: 'DATE', label: 'Recently Published' },
        },
      },
      options: {
        postType: [
          { label: 'Live', value: 'LIVE' },
          { label: 'On-Demand', value: 'ON_DEMAND' },
          { label: 'Shorts', value: 'SHORTS' },
        ],
        privacyStatus: [
          { label: 'Private', value: 'PRIVATE' },
          { label: 'Public', value: 'PUBLIC' },
          { label: 'Unlisted', value: 'UNLISTED' },
        ],
      },
      queryParamMapping: {
        ...baseQueryParamMapping,
        postType: { queryParamName: 'postType', type: 'array', elementType: 'string' },
        privacy: { queryParamName: 'privacy', type: 'array', elementType: 'string' },
        captionContain: {
          queryParamName: 'captionContain',
          type: 'array',
          elementType: 'string',
        },
        captionNotContain: {
          queryParamName: 'captionNotContain',
          type: 'array',
          elementType: 'string',
        },
      },
      scope: 'youtubeYourPosts',
      sortDetails: {
        options: [
          { label: 'Recently Published', value: 'DATE' },
          {
            title: 'Organic + Promoted',
            children: metrics.all([
              METRICS.YOUTUBE.VIDEOS_ADDED_TO_PLAYLIST,
              METRICS.YOUTUBE.AVG_VIEW_PERCENTAGE,
              METRICS.YOUTUBE.AVG_VIEW_DURATION,
              METRICS.YOUTUBE.CARD_CLICKS,
              METRICS.YOUTUBE.CARD_CLICK_RATE,
              METRICS.YOUTUBE.CARD_IMPRESSIONS,
              METRICS.YOUTUBE.CARD_TEASER_CLICKS,
              METRICS.YOUTUBE.CARD_TEASER_CLICK_RATE,
              METRICS.YOUTUBE.CARD_TEASER_IMPRESSIONS,
              METRICS.YOUTUBE.COMMENTS,
              METRICS.YOUTUBE.DISLIKES,
              METRICS.YOUTUBE.TOTAL_ENGAGEMENTS,
              METRICS.YOUTUBE.LIKES,
              METRICS.YOUTUBE.PREMIUM_VIEWS,
              METRICS.YOUTUBE.PREMIUM_WATCH_TIME,
              METRICS.YOUTUBE.SHARES,
              METRICS.YOUTUBE.SUBSCRIBERS,
              METRICS.YOUTUBE.VIDEO_VIEWS,
              METRICS.YOUTUBE.WATCH_TIME,
            ]),
          },
        ],
        default: {
          sortOrder: 'DESC',
          selected: { value: 'DATE', label: 'Recently Published' },
        },
      },
    },
    displayMetrics: metrics.all([
      METRICS.YOUTUBE.VIDEO_VIEWS,
      METRICS.YOUTUBE.AVG_VIEW_DURATION,
      METRICS.YOUTUBE.TOTAL_ENGAGEMENTS,
      METRICS.YOUTUBE.AVG_VIEW_PERCENTAGE,
    ]),
    metricLabels: metrics.all(Object.values(METRICS.YOUTUBE)),
    download: {
      pdf: {
        fileName: 'yourYouTubePostsPDF',
        type: 'youTubeYourPosts',
        label: 'Your YouTube Posts PDF',
        pendingKey: 'youTubeYourPostsReportPending',
      },
      csv: {
        fileName: 'yourYouTubePostsCSV',
        type: 'youTubeYourVideos',
        label: 'Your YouTube Posts CSV',
        pendingKey: 'youTubeYourVideosCSVPending',
      },
    },
    platformConnection: PLATFORM_CONNECTION.YOUTUBE,
    showPrivacyStatusFilter: true,
    captionTitle: 'Title or Description',
  };
};
